import Glide from '@glidejs/glide';
import WeGlide from './we_glide';
import { trackSliderInteraction } from './analytics';

const THUMBNAILS_GLIDE_SETTINGS = {
  gap: 8,
  perView: 8,
  focusAt: 0,
  bound: true,
  keyboard: false,
  peek: { before: 0, after: 50 },
  dragThreshold: false
};

export default class GlideWithThumbnails {
  constructor(mainSelector, thumbnailsSelector, mainOverrides, thumbnailsOverrides) {
    const thumbnailsSettings = {
      ...THUMBNAILS_GLIDE_SETTINGS,
      ...thumbnailsOverrides
    };

    this.mainElement = document.querySelector(mainSelector);
    this.thumbnailsElement = document.querySelector(thumbnailsSelector);
    this.mainWeGlide = new WeGlide(mainSelector, mainOverrides);
    this.thumbnailsGlide = new Glide(thumbnailsSelector, thumbnailsSettings);
    this.thumbnailsCount = this.thumbnailsElement.querySelectorAll('.glide__slide').length;
    this.thumbnailsFocusAt = Math.floor(this.thumbnailsPerView / 2);

    this.handleThumbnailsMovement();
    this.handleThumbnailClick();
  }

  handleThumbnailsMovement() {
    this.mainGlide.on('run', move => {
      const hasHiddenThumbnails = this.thumbnailsCount > this.thumbnailsPerView;

      if (hasHiddenThumbnails) {
        this.handleShouldMoveThumbnail(move);
        this.handleShouldGoToFirstImage();
        this.handleShouldGoToLastImage();
      }

      this.changeActiveThumbnail();
    });
  }

  handleShouldMoveThumbnail(move) {
    if (this.shouldMoveThumbnails(move)) {
      let nextThumbnailIndex = this.mainGlide.index - this.thumbnailsFocusAt;
      nextThumbnailIndex = this.makeSureIndexIsNotOutOfBounds(nextThumbnailIndex);
      this.goToThumbnail(nextThumbnailIndex);
    }
  }

  shouldMoveThumbnails(move) {
    const isPastFirstImages = this.mainGlide.index >= this.thumbnailsFocusAt;
    const isBeforeLastImages = this.mainGlide.index <= this.thumbnailsCount - this.thumbnailsFocusAt;
    const isMiddleImage = isPastFirstImages && isBeforeLastImages;
    const isAClick = move.direction === '=';
    const shouldMoveThumbnails = isMiddleImage || isAClick;
    return shouldMoveThumbnails;
  }

  makeSureIndexIsNotOutOfBounds(index) {
    if (index < 0) {
      return 0;
    }
    if (this.mainGlide.index + this.thumbnailsFocusAt >= this.thumbnailsCount) {
      return this.thumbnailsCount - this.thumbnailsPerView;
    }
    return index;
  }

  handleShouldGoToFirstImage() {
    const shouldGoToFirstSlide = this.mainGlide.index === 0;

    if (shouldGoToFirstSlide) {
      this.goToThumbnail(0);
    }
  }

  handleShouldGoToLastImage() {
    const shouldGoToLastImage = this.mainGlide.index === this.thumbnailsCount - 1;

    if (shouldGoToLastImage) {
      const nextThumbnailIndex = this.thumbnailsCount - this.thumbnailsPerView;
      this.goToThumbnail(nextThumbnailIndex);
    }
  }

  changeActiveThumbnail() {
    const currentActiveThumbnailSlide = this.thumbnailsElement.querySelector('.actual-active');
    currentActiveThumbnailSlide.classList.remove('actual-active');
    const nextActiveThumbnailSlide = this.thumbnailsElement.querySelectorAll('.glide__slide')[this.mainGlide.index];
    nextActiveThumbnailSlide.classList.add('actual-active');
  }

  handleThumbnailClick() {
    const thumbnails = Array.from(this.thumbnailsElement.querySelectorAll('.glide__slide'));
    thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', () => {
        this.mainGlide.go(`=${index}`);
        trackSliderInteraction(this.mainElement.dataset.name, index, 'thumbnail');
      });
    });
  }

  goToThumbnail(index) {
    this.thumbnailsGlide.go(`=${index}`);
  }

  mount() {
    this.mainGlide.mount();
    this.thumbnailsGlide.mount();
  }

  get thumbnailsPerView() {
    return this.thumbnailsGlide.settings.perView;
  }

  get mainGlide() {
    return this.mainWeGlide.glide;
  }
}
